import script from "./GenericListModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GenericListModal.vue?vue&type=script&setup=true&lang=js"

import "./GenericListModal.vue?vue&type=style&index=0&id=a6984cb8&lang=css"

const __exports__ = script;

export default __exports__